"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _propTypes = require("../prop-types");

var _utils = require("../utils");

var _View = _interopRequireDefault(require("./View"));

var _core = require("@emotion/core");

var _excluded = ["gridGap", "rowGap", "columnGap", "children", "container"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FlexBase = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var gridGap = _ref.gridGap,
      rowGap = _ref.rowGap,
      columnGap = _ref.columnGap,
      children = _ref.children,
      _ref$container = _ref.container,
      Container = _ref$container === void 0 ? _View.default : _ref$container,
      outerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var containerProps = _objectSpread(_objectSpread({}, outerProps), (0, _utils.getSpacingStyles)(['rowGap', 'columnGap'], {
    rowGap: rowGap,
    columnGap: columnGap
  }, selectors.space));

  if (gridGap) {
    containerProps.gap = (0, _utils.px)((0, _utils.cssProp)(selectors.space, gridGap));
  }

  return (0, _core.jsx)(Container, (0, _extends2.default)({
    display: "flex",
    ref: ref
  }, containerProps), children);
}); // Force TS to accept .withComponent


var FlexStyled = FlexBase;

FlexStyled.withComponent = function (tag) {
  var Container = _View.default.withComponent(tag, {
    target: "e1s41o6r0"
  });

  return /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(FlexBase, (0, _extends2.default)({}, props, {
      ref: ref,
      container: Container
    }));
  });
};

var FlexBaseWithDocs = (0, _stencilReactDesc.describe)(FlexStyled).description('View based on flex used for implementing layouts.');
FlexBaseWithDocs.propTypes = _objectSpread(_objectSpread({}, _View.default.describedPropTypes), {}, {
  flexDirection: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-direction' property for the element.").isRequired,
  gridGap: (0, _propTypes.cssValue)().description("Sets the CSS 'gap' property for the element."),
  rowGap: (0, _propTypes.cssValue)().description("Sets the CSS 'row-gap' property for the element."),
  columnGap: (0, _propTypes.cssValue)().description("Sets the CSS 'col-gap' property for the element."),
  children: _stencilReactDesc.PropTypes.node.description('Elements to lay out horizontally.')
});
var Flex = (0, _utils.withTestAttributes)({
  component: 'StencilReactFlex'
})(FlexBaseWithDocs);
Flex.displayName = 'Flex';
var _default = Flex;
exports.default = _default;